import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { Typography, Icon, LinkCTA } from "../ecosystem/";
import { DashboardTile } from "../dashboard/DashboardTile";
import DashboardTileLoader from "../dashboard/DashboardTileLoader";

const InHomeTile = (props) => {
    let loading = false;

    const { showTracker, trackerURL } = props;

    useEffect(() => {
        logUI(`MBHWeb.UI.InHomeTile.Displayed`, new Date(), Tools.getURLPath());
    }, []);

    const { inHomeEligibilityMessage } = props;

    return (
        <>
            {loading ? (
                <DashboardTileLoader tilename="In-home Vaccines" />
            ) : (
                <DashboardTile
                        className="in-home-tile"
                        heading={
                            <div className="col-12 d-flex">
                                <div className="in-home-tile__icon">
                                    <Icon name="covid-19-vaccine" set="brand" />
                                </div>
                                <div className="in-home-tile__heading">
                                    <Typography type="heading-01" bold color="$color-primary-a2" tag="div">
                                        In-home Vaccines
                                    </Typography>
                                    <Typography type="body-01" tag="div">
                                        Get vaccinated from the comfort of home. Healthcare, your way.
                                    </Typography>
                                </div>
                            </div>
                        }
                >
                    <div className="col-12 in-home-tile__body">
                            <div className="in-home-tile__body-content">
                                {(showTracker || inHomeEligibilityMessage) && (
                                    <Typography type="body-02" color="$color-primary-a2" tag="div">
                                        {showTracker
                                            ? "Your vaccines are on the way!"
                                            : inHomeEligibilityMessage}
                                    </Typography>
                                )}

                                {!inHomeEligibilityMessage && !showTracker && (
                                    <Typography type="body-02" color="$color-primary-a2" tag="div">
                                        You and/or a family member are eligible for a vaccine.
                                    </Typography>
                                )}
                            </div>
                            <div className="in-home-tile__body-link">
                                {showTracker ? (
                                    trackerURL &&
                                    <LinkCTA
                                        href={trackerURL}
                                        target='_blank'
                                        onClick={() => {
                                            logUI(
                                                "MBHWeb.UI.InHomeTile.TrackStatus.Clicked",
                                                new Date(),
                                                Tools.getURLPath()
                                            );
                                        }}>Track</LinkCTA>
                                )
                                    : (
                                        <LinkCTA
                                            to="/inhomevaccine"
                                            onClick={() => {
                                                logUI(
                                                    "MBHWeb.UI.InHomeTile.ScheduleVisit.Clicked",
                                                    new Date(),
                                                    Tools.getURLPath()
                                                );
                                            }}>Schedule a Visit</LinkCTA>
                                    )
                                }
                            </div>
                    </div>
                </DashboardTile>
            )}
        </>
    );
};

const mapStateToProps = (state) => {
    const bffDashboardData = state.dashboard.bffDashboardData;
    const visitsData = bffDashboardData?.data?.visits || [];
    let trackURL = null;
    const isInhomeAvail = visitsData.filter((visit, index) => {
        return visit.isInHomeVaccination === true;
    });

    //check whether visit date is today
    let isVisitToday = false;
    if (
        isInhomeAvail &&
        isInhomeAvail.length > 0 &&
        isInhomeAvail[0].appointmentDateTime
    ) {
        isVisitToday = Tools.isVisitToday(isInhomeAvail[0].appointmentDateTime);
    }

    if (isInhomeAvail.length > 0) {
        trackURL = isInhomeAvail[0].inHomeVaccinationTrackerUrl;
    }
    //let inHomeEligibilityMessage = isInhomeAvail.length > 0 ? isInhomeAvail[0].inHomeEligibilityMessage : null;
    let inHomeEligibilityMessage =
        bffDashboardData?.data?.features?.inHomeVaccination?.eligibilityMessage;

    return {
        hasMyChart: !state.common.epicEHRDown && state.domain.hm,
        showTracker: isInhomeAvail.length === 0 || !isVisitToday ? false : true,
        trackerURL: trackURL,
        inHomeEligibilityMessage: inHomeEligibilityMessage,
    };
};

export default connect(mapStateToProps)(InHomeTile);
